<template>
  <div class="main-container">
    <div class="bread">
      <router-link :to="{ name: 'MemberClasses' }">我的班级</router-link>
      <span class="slash">/</span>
      <span class="current">{{ detail.class_name }}</span>
    </div>
    <div class="member-classes-detail">
      <img class="member-classes-cover" :src="detail.cover_image" />
      <div class="member-classes-detail_main">
        <div>
          <div class="member-classes-title bold6">{{ detail.class_name }}</div>
          <div class="member-classes-info">
            <span>
              <span>共</span>
              <span class="member-classes-course_num bold6">
                <span>{{ detail.courses_count }}</span>
              </span>
              <span>门课程</span>
            </span>
            <span v-if="detail.course_classify_name">
              <span>{{ detail.course_classify_name }}</span>
            </span>
            <span v-if="detail.grade_name">{{ detail.grade_name }}</span>
          </div>
          <div class="member-classes-header_teacher">
            <span>班主任：</span>
            <span
              class="name"
              v-for="(teacher, index) in detail.head_teachers"
              :key="index"
            >
              {{ teacher.head_teacher_name }}
              <span v-if="index != detail.head_teachers.length - 1">/</span>
            </span>
          </div>
        </div>
        <div>
          <div class="member-classes-join">
            <span>
              <span class="member-classes-label">入班时间：</span>
              <span class="member-classes-value">
                <span>{{ detail.join_time | tsFormatLong }}</span>
              </span>
            </span>
            <span>
              <span class="member-classes-label">有效期至：</span>
              <span
                class="member-classes-value"
                v-if="detail.valid_end_time == 0"
              >
                <span>长期有效</span>
              </span>
              <template v-else>
                <span class="member-classes-value">
                  <span>{{ detail.valid_end_time | tsFormatLong }}</span>
                </span>
              </template>
            </span>
          </div>
          <div class="member-classes-rate">
            <span class="member-classes-label">学习进度：</span>
            <span class="member-classes-rate_value">
              <span>{{ detail.progress_rate }}%</span>
            </span>
            <div class="member-classes-progress">
              <div
                class="member-classes-progress_value"
                :style="{ width: detail.progress_rate + '%' }"
              ></div>
            </div>
          </div>
        </div>
      </div>
      <div
        class="member-classes-btn"
        v-if="detail.schedule_image"
        @click="showScheduleImage = true"
      >
        查看课表
      </div>
      <div
        class="member-classes-btn member-classes-btn-publish"
        @click="targetPost"
        v-if="
          commonSetting.switch_community_module &&
          circle_module.class &&
          this.detail.hidden == 1
        "
      >
        发布帖子
      </div>
    </div>
    <div class="member-classes-main" v-if="detail.id">
      <el-tabs class="member-classes-tabs el-tabs-common" v-model="currentTab">
        <el-tab-pane
          v-for="(item, index) in tabs"
          :key="index"
          :name="item.name"
          :label="item.label"
        ></el-tab-pane>
      </el-tabs>
      <StudyCalendar
        v-if="currentTab == 'calendar'"
        :timesUrl="'/api/app/user/classCalendar/' + id"
        :dateUrl="getCalendarUrl"
        :flexStyle="true"
      ></StudyCalendar>
      <MemberClassesCourse
        v-else-if="currentTab == 'course'"
      ></MemberClassesCourse>
      <template v-else-if="currentTab == 'homework'">
        <div
          v-if="$store.state.commonSetting.class_homework_module == 1"
          style="padding: 0 24px"
        >
          <HomeworkList
            class="member-classes-homework"
            :classId="id"
            :isFromMember="false"
          >
            <EmptyNew slot="empty" title="暂无作业"></EmptyNew>
          </HomeworkList>
        </div>
      </template>
      <MemberClassesAnnouncement
        v-else-if="currentTab == 'notice'"
      ></MemberClassesAnnouncement>
      <MemberClassesWare v-else-if="currentTab == 'ware'"></MemberClassesWare>
      <MemberClassesCircle
        v-else-if="currentTab == 'circle'"
        :group_id="detail.group_id"
      ></MemberClassesCircle>
      <MemberClassesMeeting
        v-else-if="currentTab == 'meeting'"
      ></MemberClassesMeeting>
    </div>
    <el-dialog
      class="member-classes-schedule_dialog"
      :visible.sync="showScheduleImage"
      width="auto"
    >
      <img class="member-classes-schedule_img" :src="detail.schedule_image" />
    </el-dialog>
    <PostConfirm
      :visible.sync="postVisible"
      :groupId="detail.group_id"
      origin="1"
    ></PostConfirm>
  </div>
</template>
<script>
import StudyCalendar from "./ClassStudyCalendar.vue";
import MemberClassesCourse from "@/modules/stu/components/classes/MemberClassesCourse.vue";
import HomeworkList from "@/modules/stu/components/HomeworkList.vue";
import MemberClassesAnnouncement from "@/modules/stu/components/classes/MemberClassesAnnouncement.vue";
import MemberClassesWare from "@/modules/stu/components/classes/MemberClassesWare.vue";
import MemberClassesCircle from "@/modules/stu/components/classes/MemberClassesCircle.vue";
import PostConfirm from "@/components/community/components/PostConfirm.vue";
import EmptyNew from "@/components/EmptyNew.vue";
import MemberClassesMeeting from "@/modules/stu/components/classes/MemberClassesMeeting";
export default {
  name: "MemberClassesDetail",
  components: {
    StudyCalendar,
    MemberClassesCourse,
    HomeworkList,
    MemberClassesAnnouncement,
    MemberClassesWare,
    MemberClassesCircle,
    PostConfirm,
    MemberClassesMeeting,
    EmptyNew,
  },
  data() {
    return {
      id: this.$route.params.id,
      group_id: 0,
      detail: {},
      showScheduleImage: false,
      currentTab: "calendar",
      dialogVisible: { show: false },
      community: {
        communityType: "", //发帖类型，1是图文，2是视频
      },
      rules: {
        //规则
        communityType: [
          { required: true, message: "请选择发帖类型", trigger: "blur" },
        ],
      },
      postVisible: false, //发帖弹窗
    };
  },
  async created() {
    this.detail = await this.$http.get("/api/app/user/class/" + this.id);
    // 下架后不能继续学习&非上架，不允许查看班级详情
    if (this.detail.is_go_to_study == 2 && this.detail.status == 2) {
      this.$warning("班级已下架无法继续学习，如有疑问请联系班主任～", {
        duration: 2000,
      });
      this.$router.back();
    }
  },
  computed: {
    commonSetting() {
      return this.$store.state.commonSetting;
    },
    circle_module() {
      return this.$store.state.commonSetting.circle_module;
    },
    tabs() {
      let tabs = [
        { name: "calendar", label: "学习日历" },
        { name: "course", label: "班级课程" },
      ];
      if (this.$store.state.commonSetting.class_homework_module == 1) {
        tabs.push({ name: "homework", label: "班级作业" });
      }
      tabs.push({ name: "ware", label: "班级课件" });
      tabs.push({ name: "notice", label: "班级公告" });
      if (
        this.commonSetting.switch_community_module &&
        this.circle_module.class == 1 &&
        this.detail.hidden == 1
      ) {
        tabs.push({ name: "circle", label: "班级圈子" });
      }
      tabs.push({ name: "meeting", label: "班会" });
      return tabs;
    },
  },
  methods: {
    getCalendarUrl(time) {
      return "/api/app/user/classCalendar/" + this.id + "/" + time;
    },
    // 跳转发帖
    targetPost() {
      const that = this;
      if (that.$store.state.token) {
        if (!this.detail.group_id) {
          that.$message({
            type: "danger",
            message: "请先加入圈子",
          });
          return;
        }
        this.postVisible = true;
      } else {
        this.$LoginModal.login({ type: "passwordLogin", store: this.$store });
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.main-container {
  overflow: hidden;
}
.member-classes-detail {
  background: #ffffff;
  border-radius: 4px;
  padding: 24px;
  display: flex;
  position: relative;
  margin-bottom: 16px;
}
.member-classes-cover {
  width: 300px;
  height: 199px;
  margin-right: 24px;
}
.member-classes-title {
  font-size: 16px;
  font-family: PingFangSC, PingFangSC-Semibold;
  line-height: 22px;
  margin-bottom: 8px;
}
.member-classes-info {
  color: #999999;
  margin-bottom: 8px;
}
.member-classes-course_num {
  font-family: PingFangSC, PingFangSC-Semibold;
  color: #666666;
  margin: 0 4px;
}
.member-classes-info > span,
.member-classes-join > span {
  padding-right: 10px;
  margin-right: 10px;
  position: relative;
  &::after {
    content: "";
    position: absolute;
    width: 1px;
    height: 16px;
    top: 2px;
    right: 0;
    background: #cccccc;
  }
  &:last-child::after {
    display: none;
  }
}
.member-classes-header_teacher {
  color: #999;
  .name {
    color: #666;
  }
}
.member-classes-join {
  margin-bottom: 14px;
}
.member-classes-label {
  color: #999;
}
.member-classes-value {
  color: #666;
}
.member-classes-rate {
  display: flex;
  align-items: center;
}
.member-classes-progress {
  width: 711px;
  height: 10px;
  opacity: 1;
  background: linear-gradient(180deg, #eef1f0, #e7ebea 51%, #e6ebea);
  border-radius: 5px;
  position: relative;
}
.member-classes-progress_value {
  position: absolute;
  height: 100%;
  left: 0;
  top: 0;
  border-radius: 5px;
  background: linear-gradient(180deg, #55e5b9 2%, #25c694);
}
.member-classes-rate_value {
  color: #22c391;
  margin-right: 16px;
}
.member-classes-detail_main {
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}
.member-classes-btn {
  width: 96px;
  height: 36px;
  box-sizing: border-box;
  border: 1px solid #bfbfbf;
  border-radius: 5px;
  line-height: 34px;
  cursor: pointer;
  position: absolute;
  top: 20px;
  right: 132px;
  text-align: center;
  cursor: pointer;
}
.member-classes-btn-publish {
  right: 24px;
  background-color: $primary-color;
  color: #fff;
  border: 0;
}
.member-classes-schedule_dialog {
  /deep/ {
    .el-dialog {
      background: transparent;
      box-shadow: none;
      display: inline-block;
      left: 50%;
      transform: translateX(-50%);
    }
    .el-dialog__header {
      padding: 0;
    }
    .el-dialog__body {
      padding: 0;
      display: inline-block;
    }
    .el-dialog__headerbtn {
      width: 32px;
      height: 32px;
      background: url("~@/assets/images/classes/close@2x.png") no-repeat center
        center/100% 100%;
      top: -46px;
      right: -46px;
    }
    .el-icon-close {
      display: none;
    }
  }
}
.member-classes-schedule_img {
  max-width: 1000px;
  max-height: 485px;
  display: block;
  margin: 0 auto;
}
.member-classes-main {
  margin-bottom: 24px;
  background: white;
  border-radius: 4px;
  overflow: hidden;
}
.member-classes-tabs {
  padding: 12px 24px 0 24px;
  /deep/ {
    .el-tabs__header {
      margin-bottom: 0;
    }
  }
}
.member-classes-homework {
  padding: 0;
  /deep/ {
    .el-scrollbar__wrap {
      margin-bottom: 0 !important;
    }
  }
}
</style>
